import React from 'react';

import { createStyles, ListItem, ListItemText, Theme, withStyles, WithStyles } from '@material-ui/core';
import { ListItemProps } from '@material-ui/core/ListItem';

import Typography from './Typography';

const styles = ({ custom }: Theme) =>
  createStyles({
    listItemTextSecondary: {
      color: custom.palette.colorDarkCyan,
      fontFamily: 'roboto mono',
    },
  });

export type Squiggly = {
  id: string;
  name: string;
};

export interface ListItemSquigglyProps extends Omit<ListItemProps, 'classes'>, WithStyles<typeof styles> {
  squiggly: Squiggly;
}

const ListItemSquiggly: React.FC<ListItemSquigglyProps> = ({ classes, squiggly, onClick, ...rest }) => (
  <ListItem button={!!onClick} onClick={onClick} {...rest}>
    <ListItemText
      disableTypography
      primary={<Typography variant="body1StrongBold">{squiggly.name}</Typography>}
      secondary={
        <Typography className={classes.listItemTextSecondary} variant="captionBold" noWrap>
          {squiggly.id}
        </Typography>
      }
    />
  </ListItem>
);

export default withStyles(styles)(ListItemSquiggly);
